import { required, useInput } from "ra-core";
import { TextInput } from "@/components/admin/text-input";

// Native color picker wired to react-hook-form (same approach as SettingsPage).
const ColorInput = ({ source }: { source: string }) => {
  const { field } = useInput({ source, defaultValue: "#99c1de" });
  return (
    <div className="flex flex-col gap-1">
      <span className="text-sm">Color</span>
      <input
        type="color"
        {...field}
        value={field.value || "#99c1de"}
        className="w-12 h-9 cursor-pointer rounded border bg-transparent p-0.5"
      />
    </div>
  );
};

export const GroupInputs = () => (
  <div className="flex flex-col gap-4">
    <TextInput source="name" validate={required()} helperText={false} />
    <ColorInput source="color" />
  </div>
);
